const css = `@charset "UTF-8";
.roles-header-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
@media (max-width: 576px) {
  .roles-header-options {
    gap: 8px;
    /* Ajustar botones para dispositivos móviles */
  }
  .roles-header-options > button,
  .roles-header-options > div {
    margin-bottom: 8px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1JvbGVzIiwic291cmNlcyI6WyJSb2xlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFHQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBTkY7SUFPSTtBQUVBOztFQUNBO0FBQUE7SUFFRSIsInNvdXJjZXNDb250ZW50IjpbIi5lbXBsb3llZXMtcGFnZSB7XG59XG5cbi5yb2xlcy1oZWFkZXItb3B0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgZ2FwOiAxNnB4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIEBtZWRpYSAobWF4LXdpZHRoOiA1NzZweCkge1xuICAgIGdhcDogOHB4O1xuXG4gICAgLyogQWp1c3RhciBib3RvbmVzIHBhcmEgZGlzcG9zaXRpdm9zIG3Ds3ZpbGVzICovXG4gICAgPiBidXR0b24sXG4gICAgPiBkaXYge1xuICAgICAgbWFyZ2luLWJvdHRvbTogOHB4O1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
